module.exports = require('./helpers/bundle-url').getBundleURL('1fz0F') + "logo-dark.ba5147f0.svg";